export default __webpack_public_path__ + "static/media/time-add-submit.f1605cb2.png";